var name = "UNT-01_2b4p_02s";
var uuid = "1f176ba0-0590-5c63-a840-6252897f79ba";
var pos = [
	0,
	0,
	0
];
var rot = [
	0,
	0,
	0
];
var size = [
	11.425,
	3.035,
	9.1875
];
var anchor = [
	0.5,
	0,
	0.7823129156406008
];
var color = "#cccccc";
var alpha = 1;
var rg = true;
var type = "Apartment";
var children = [
	{
		name: "balcony",
		uuid: "1b693765-ba23-504f-88a5-d6710f800523",
		pos: [
			2.075,
			0.145,
			-7.1875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.5,
			0.16,
			2
		],
		anchor: [
			0,
			0,
			0
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Balcony",
		children: [
			{
				name: "floor",
				uuid: "8ff883d4-6535-50a5-acf9-acdc84bd4f69",
				pos: [
					1.75,
					0.08,
					1
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.5,
					0.16,
					2
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			}
		]
	},
	{
		name: "Bedroom Double",
		uuid: "181b5500-4e7a-5420-8355-4aaff6edd0ae",
		pos: [
			-3.825,
			0.305,
			-5.914
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.5,
			2.4384,
			3.347
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "Bathroom",
		uuid: "bc5c42d8-d385-5080-b92b-e254cd638a5f",
		pos: [
			-4.5286,
			0.305,
			-3.1415
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2.0928,
			2.4384,
			2.008
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fe4365",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Bathroom",
			polygon: [
				[
					-5.575,
					0.305,
					-4.1455
				],
				[
					-5.575,
					0.305,
					-2.4425
				],
				[
					-4.88,
					0.305,
					-2.4425
				],
				[
					-4.88,
					0.305,
					-2.1375
				],
				[
					-3.4822,
					0.305,
					-2.1375
				],
				[
					-3.4822,
					0.305,
					-4.1455
				],
				[
					-5.575,
					0.305,
					-4.1455
				]
			]
		}
	},
	{
		name: "Hallway",
		uuid: "64bcd922-87ec-55c7-aafd-856ef4ac8878",
		pos: [
			-1.2437,
			0.305,
			-2.715
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.0125,
			2.4384,
			1.16
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway"
		}
	},
	{
		name: "Utility",
		uuid: "a1aba15f-fabf-5465-af65-87b8c9488e9e",
		pos: [
			-1.3362,
			0.305,
			-1.0888
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			0.8275,
			2.4384,
			1.9025
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#c44d58",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Utility"
		}
	},
	{
		name: "Bedroom Double",
		uuid: "37405297-69c2-51be-a896-c2861d717b57",
		pos: [
			0,
			0.305,
			-5.2138
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.5,
			2.4384,
			3.6475
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble",
			polygon: [
				[
					1.75,
					0.305,
					-7.0375
				],
				[
					-1.75,
					0.305,
					-7.0375
				],
				[
					-1.75,
					0.305,
					-3.39
				],
				[
					-0.69,
					0.305,
					-3.39
				],
				[
					-0.5875,
					0.305,
					-3.39
				],
				[
					-0.5875,
					0.305,
					-3.4328
				],
				[
					-0.5875,
					0.305,
					-3.94
				],
				[
					1.75,
					0.305,
					-3.94
				],
				[
					1.75,
					0.305,
					-7.0375
				]
			]
		}
	},
	{
		name: "Kitchen - Living - Dining",
		uuid: "b6d0d38a-2254-5b3a-8fa6-49c8cd8036e3",
		pos: [
			2.3738,
			0.305,
			-3.5875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			6.4025,
			2.4384,
			6.9
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#00a0b0",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "KitchenLivingDining",
			polygon: [
				[
					-0.8275,
					0.305,
					-0.1375
				],
				[
					1.75,
					0.305,
					-0.1375
				],
				[
					1.75,
					0.305,
					-0.7875
				],
				[
					2.0766,
					0.305,
					-0.7875
				],
				[
					2.36,
					0.305,
					-0.7875
				],
				[
					2.36,
					0.305,
					-0.1375
				],
				[
					5.575,
					0.305,
					-0.1375
				],
				[
					5.575,
					0.305,
					-7.0375
				],
				[
					2.075,
					0.305,
					-7.0375
				],
				[
					2.075,
					0.305,
					-3.295
				],
				[
					-0.387,
					0.305,
					-3.295
				],
				[
					-0.6425,
					0.305,
					-3.295
				],
				[
					-0.6425,
					0.305,
					-2.04
				],
				[
					-0.8275,
					0.305,
					-2.04
				],
				[
					-0.8275,
					0.305,
					-0.1375
				]
			]
		}
	},
	{
		name: "Storage",
		uuid: "2acf858b-b0cb-5ce9-9be5-921fdddf53d8",
		pos: [
			0.6288,
			0.305,
			-3.57
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			0.55,
			2.4384,
			2.2425
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Hallway",
		uuid: "b9247e7e-0d05-59cd-b4cf-00b97bb1a6fd",
		pos: [
			-2.7311,
			0.305,
			-3.1415
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.3122,
			2.4384,
			2.008
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway"
		}
	},
	{
		name: "module",
		uuid: "b1b3e459-7730-5204-9248-2e60465901c8",
		pos: [
			-3.825,
			1.5175,
			-2.8625
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.775,
			3.035,
			5.725
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "a28e4042-390d-57a5-8c65-2d7f48037608",
				pos: [
					0,
					0.0725,
					-2.7937
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.5,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "707c7dd2-1600-546c-b92a-468f9fffd8f3",
						pos: [
							0,
							0.315,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.6,
							0.8,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|01|UK-WNF0002",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "f86d228d-c1df-5733-837f-27bad945e1a8",
				pos: [
					-1.8188,
					0.0725,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.5875,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "afd0b1b1-4b61-5e55-bce3-819c157db24b",
				pos: [
					-0.0688,
					0.0725,
					2.7938
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6375,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "09250870-5608-538a-ae7f-63cf2c1e0e9e",
						pos: [
							-1.0538,
							-0.2225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.01,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|01|UK-DIS0001",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: true
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "a6e787a1-cb4f-5df0-82ae-a0d89a6f27f2",
				pos: [
					1.8188,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.725,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "990cbe29-7e42-5b96-b8b9-cb68ce69300b",
						pos: [
							-2.095,
							-0.24,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.05,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "a608532e-3070-58e0-95b8-40c37b07d1c8",
				pos: [
					0,
					-1.37,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.45,
					0.295,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FPA|02|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "764e51eb-a5ef-5b0f-8d0f-ff721e17c09e",
				pos: [
					0,
					0.07,
					0.6695
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.55,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "b178bdf0-163f-582f-8b82-37c091f3b2cd",
						pos: [
							-1.2515,
							-0.22,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "6528c571-078d-5914-8383-e1b3eec1c352",
				pos: [
					0.3903,
					0.07,
					1.7335
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					2.033,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "aaa2f8d4-08b2-53cf-8d36-28f371c93321",
						pos: [
							0.504,
							-0.22,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "9976bbba-4160-5d2e-9d23-3ca5b1e38eeb",
				pos: [
					-1.1025,
					0.07,
					2.585
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.33,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "e2e23ee0-6cfb-5a48-8dfd-d1d3d3389253",
				pos: [
					-1.4625,
					0.07,
					2.4675
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					0.625,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "ceiling",
				uuid: "1980c253-027e-5f2d-b1ac-14080a364d9d",
				pos: [
					0,
					1.44,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.45,
					0.155,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "5734cac5-c2c7-502b-a772-a63f1098a958",
		pos: [
			3.825,
			1.5175,
			-1.5875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.775,
			3.035,
			7.175
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "ca0b1d63-847b-5332-ae4b-75a4b9f68bf9",
				pos: [
					0,
					0.0725,
					-3.5188
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.5,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "b66f478a-7267-5664-90f4-826d6518e100",
						pos: [
							0,
							-0.2225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.738,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "c5df524d-87ea-5c25-830a-f3dc476a70c1",
				pos: [
					0,
					0.0725,
					3.5187
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.5,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "36595ce3-f984-5d9d-b359-8fdb8d1ac4e9",
				pos: [
					1.8188,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.175,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "b2c47e87-ff0a-5429-9a52-d715a38b5807",
				pos: [
					0,
					-1.37,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					6.9,
					0.295,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FPA|02|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "b1571035-2b29-549e-b154-48fd356e1649",
				pos: [
					-1.8188,
					0.0725,
					-1.6463
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					3.8825,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "cc8f51f2-686e-5383-9806-390c666842a6",
				pos: [
					-1.8188,
					0.0725,
					3.1937
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.7875,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "5eefca54-6921-5371-9543-15f1482deec2",
				pos: [
					-1.5125,
					0.07,
					3.185
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.58,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "82200275-25e5-51a4-8f93-20c44c9fa1d8",
				pos: [
					-1.62,
					0.07,
					2.8475
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					0.31,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "ceiling",
				uuid: "2690565e-2960-528e-9927-dd88dba148cb",
				pos: [
					0,
					1.44,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					6.9,
					0.155,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "45d981f8-532a-54a8-b0cc-fc5d4e276910",
		pos: [
			0,
			1.5175,
			-1.5875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.775,
			3.035,
			7.175
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "c94e1ffa-a976-5001-accd-cd676293f6cb",
				pos: [
					0,
					0.0725,
					-3.5188
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.5,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "74454d57-d966-5afc-a53e-8709eae7cb00",
						pos: [
							0,
							0.315,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.6,
							0.8,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|01|UK-WNF0002",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "6bb43cb3-6bc9-5490-93a9-98f5f318b39f",
				pos: [
					0,
					0.0725,
					3.5188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.775,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "c08a2d6e-e498-5c72-a8c5-8f3fceee15a3",
				pos: [
					1.8187,
					0.0725,
					-1.6462
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					3.8825,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "3b18dfb6-43e0-536f-a6d5-14a3edbe727f",
				pos: [
					0,
					-1.37,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					6.9,
					0.295,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FPA|02|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "3ec655a6-c007-53e1-89aa-30a14e2775ad",
				pos: [
					-1.2437,
					0.07,
					1.5
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					1.0125,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "e5dd410b-c42d-5eff-a00f-c51db643b835",
				pos: [
					-0.875,
					0.07,
					2.4987
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					1.9025,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "96fd76a7-52c6-50fb-bcb4-63ca4a5dd115",
						pos: [
							0.0879,
							-0.09,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.498,
							2.35,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0002",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "989edf27-76bd-5dd0-94ff-453f29bb81ed",
				pos: [
					-0.69,
					0.07,
					0.92
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					1.255,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "7a7d01cb-5267-5dc5-a492-7909c7f52c36",
						pos: [
							-0.078,
							-0.22,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "802d4239-ab1a-543c-8bfd-515b6aeae818",
				pos: [
					-1.1687,
					0.07,
					0.245
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					1.1625,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "bc35f2db-1844-5e12-9ae5-ed5b1ea3a2f0",
						pos: [
							0.0643,
							-0.22,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "0aaec604-a6f0-59f1-b3c5-6f26ba9308a9",
				pos: [
					-1.8188,
					0.0725,
					-0.0687
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.0375,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "c666eef8-3c58-5358-b37f-e93e0b1cf2ac",
						pos: [
							0.8887,
							-0.24,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.05,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "08e79b6a-8495-5cdb-b773-bc4128282e65",
				pos: [
					1.8187,
					0.0725,
					3.125
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.65,
					2.72,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "b2e1f994-5977-5acb-b245-bb4ddde87963",
				pos: [
					0.5812,
					0.07,
					-0.305
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					2.3375,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "b0329e61-cff0-55fe-b0ee-c708542f847e",
				pos: [
					-0.54,
					0.07,
					0.0175
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.55,
					2.585,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "ceiling",
				uuid: "a734cecb-cd5b-5192-89f1-c390ebae9d3e",
				pos: [
					0,
					1.44,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					6.9,
					0.155,
					3.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	}
];
var data = {
	level: -1,
	levelId: "",
	occupants: 4,
	bedrooms: 2,
	habitableRooms: 3,
	nia: 70.6015,
	muscleID: "",
	category: "2B4P",
	closeCorridor: true,
	closeDirection: [
		1,
		0,
		0
	],
	closeLength: 7.6
};
var UK02_2B4P_02 = {
	name: name,
	uuid: uuid,
	pos: pos,
	rot: rot,
	size: size,
	anchor: anchor,
	color: color,
	alpha: alpha,
	rg: rg,
	type: type,
	children: children,
	data: data
};

export { alpha, anchor, children, color, data, UK02_2B4P_02 as default, name, pos, rg, rot, size, type, uuid };
//# sourceMappingURL=UNT-01-2b4p-02s.json.js.map
